export default {"src":"/_next/static/media/facebook.e0d7e1e4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};